import { ProgressFormLeftMenu as AntdProgressFormLeftMenu } from "@empglabs/backoffice-ui-kit"

const ProgressFormLeftMenu = props => {
  return <AntdProgressFormLeftMenu {...props} />
}

export default ProgressFormLeftMenu
